<template>
  <div class="page-model-detail" v-show="isShow && isMounted">
    <div class="detail-cont">
      <el-breadcrumb class="add-breadcrumb moee" separator="/">
        <el-breadcrumb-item >
          <a :href="baseUrl+'/nAnimateMake?plate=3'" >动画制作</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item >
          <a :href="baseUrl+'/model?plate=3'" >素材</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item >
          <a :href="baseUrl+'/audio?plate=3'" >音效库</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>音效详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="top-info article-top-info">
        <div class="art-top-title"><a :href="baseUrl + '/audio/detail?id=' + modelDetail.id + '&plate=3'">{{modelDetail.modelName}}</a></div>
        <div class="type-tags">
        </div>
        <div class="zc-count clearfix">
          <i class="icon see"></i><span class="much">{{modelDetail.viewCount}}</span>
          <i class="icon pinglun"></i><span class="much">{{modelDetail.commentCount}}</span>
          <i class="icon fenxiang"></i><span class="much">{{modelDetail.shareCount}}</span>
          <!-- <span class="much"><i class="el-icon-more"></i></span> -->
          <!-- <span class="tips"><i class="el-icon-warning"></i> 未经作者授权，禁止转载</span> -->
          <span class="date">{{model.createTime | formatTime}}</span>
        </div>
      </div>
      <div class="con-info clearfix">
        <div class="left-info">
          <div class="play-audio">
            <div class="pan">
              <img class="pan-img" :class="{'paused': !playState}" :src="require('./play_audio.png')" alt="">
              <div class="mai" :class="{'play': playState}"><img class="mai-img" :src="require('./m.png')" alt=""></div>
            </div>
            <vue-audio v-if="audioSrc != ''" :audio-src='audioSrc' @change="changeState"></vue-audio>
          </div>
          <div class="model-shuom">
            <div class="tit">音效说明</div>
            <div class="words">
              {{model.modelDescription}}
            </div>
          </div>
          <div class="articled-zan-cai">
            <div class="item" :class="{'active': model.likeFlag}" v-on:click="likeEvent(model.id,model.belongSection)">
              <i class="icon zan"></i>
              <span>{{model.likeCount}}</span>
            </div>
            <div class="item" :class="{'active': model.disLikeFlag}" v-on:click="disLikeEvent(model.id,model.belongSection)">
              <i class="icon cai"></i>
              <span>{{model.dislikeCount}}</span>
            </div>
          </div>

          <!-- 评论 -->
          <div class="pro-work-item clearfix" ref="lessonItemThree" style="border-top: 5px solid #f6f6f6;">
            <div class="item-infoes same-left">

              <talkPart :objType="6" :objId="objId" v-if="isReload" :loadShow="true"
                        :isOperate="false" ref="talkPart"></talkPart>

            </div>
          </div>
          <!-- 评论 -->

        </div>
        <div class="right-info">
          <div class="price-num clearfix">
            <div class="price" v-if="isFree">免费</div>
            <div class="price" v-else>￥{{model.modelPrice}}</div>
            <!-- <div class="num">作品编号：112255</div> -->
          </div>
          <ul class="muchs clearfix">
            <li>下载<span>{{model.downLoadCount}}</span></li>
            <li>评论<span>{{model.commentCount}}</span></li>
            <li>收藏<span>{{model.collectCount}}</span></li>
          </ul>
          <div class="btns" v-if="isShow && isMounted">
            <el-button slot="reference" class="btn mar-btn" @click="download" v-if="!global.isLogin"
                       size="large"
                       type="warning">立即下载
            </el-button>
            <el-popover v-else-if="global.isLogin && (payStatus || isFree)"
                        placement="bottom"
                        width="300"
                        trigger="click">
              <el-table :data="fileList">
                <el-table-column min-width="180" property="name" label="名称"></el-table-column>
                <el-table-column min-width="80" property="uri" label="下载" :key="model.id" align="center">
                  <template slot-scope="scope">
                    <el-button @click="addDownloadCount(scope.row)" size="mini">下载</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button slot="reference" class="btn mar-btn" size="large"
                         type="warning">立即下载
              </el-button>
            </el-popover>

            <el-button size="large" v-if="payShow" type="danger" @click="toPayXy" class="btn mar-btn">立即付费
            </el-button>

            <el-button v-if="model.collectFlag" @click="cancelCollect(model.id)" class="btn mar-btn ls"
                       size="large">已收藏
            </el-button>
            <el-button v-else class="btn mar-btn ls" @click="commitCollect(model.id)" size="large">收 藏
            </el-button>
          </div>
          <div class="geshi">
            <div class="tit-com">文件格式：</div>
            <div class="gs-info">
              <div class="one-item clearfix">
                <span class="size" v-if="model.formatStr && model.formatStr.length>2">{{model.formatStr.substr(0,model.formatStr.length-1)}}</span>
              </div>
            </div>
          </div>
          <div class="author-info">
            <div class="info clearifx">
              <div class="gz-btn" v-show="global.isLogin && global.userModel.id != userInfo.userId">
                <el-button v-if="userInfo.followStatus == 2" @click="undoFollower(userInfo.userId)">互相关注
                </el-button>
                <el-button v-if="userInfo.followStatus == 1" @click="undoFollower(userInfo.userId)">已关注
                </el-button>
                <el-button class="wgz-btn" v-if="userInfo.followStatus == 0"
                           @click="follower(userInfo.userId)"><i class="el-icon-plus"></i> 关注
                </el-button>
              </div>
              <div class="lf-info clearfix" v-show="isMounted">
                <a :href="baseUrl + '/home?userId=' + modelDetail.creatorId" class="avatar"
                             :style="{'background-image': 'url(' + `http://iss.21teacher.com/avatar/125/${modelDetail.creatorId}/20.jpg` + ')'}"></a>
                <div class="name-qm">
                  <div class="nm oe">
                    <a :href="baseUrl + '/home?userId=' + modelDetail.creatorId">
                      {{userInfo.userName}}
                    </a>
                  </div>
                  <div class="qm oe">{{userInfo.signature}}</div>
                </div>
              </div>
            </div>
            <div class="audio-works clearfix">
              <a class="itemm" target="_blank" v-for="(item, index) in modelDetail.userModels" :key="index"
                 :href="baseUrl + '/modeldetail?id=' + item.id + '&plate=3'">
                <img :src="require('@/assets/images/audio_img.png')" alt="">
                <p>{{item.modelName}}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
            :visible.sync="dialogXieyi"
            :width="$store.state.app.device === 'desktop' ? '70%' : '95%'"
            :top="$store.state.app.device === 'desktop' ? '60px' : '10px'"
            :close-on-click-modal="false"
            center
    >
      <xie-yi></xie-yi>
      <div style="text-align: center;margin-top: 10px;">
        <el-checkbox v-model="agree">阅读并同意协议</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button :type="agree ? 'primary' : 'info'" :disabled="!agree" @click="toPay">确 定</el-button>
            </span>
    </el-dialog>
    <ul class="right-side-btns">
      <li @click="doShare">分&nbsp;&nbsp;&nbsp;&nbsp;享</li>
      <li @click="scrollItem(2)">评&nbsp;&nbsp;&nbsp;&nbsp;论</li>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios';
  import vue from 'vue';
  import modelApi from '@/api/model'
  import homeApi from '@/api/home'
  import apiService from '@/api/index'
  import talkPart from '@@/pub/talkpart/talkpart'
  import updateTdk from "@/utils/tdk";
  import {mapState} from "vuex";
  import VueAudio from './vueAudio'
  import XieYi from '../../xieyi/xieyi'
  import sideBarMixin from '../../../course/detail/minxin'

  vue.prototype.$axios = axios;
  export default {
    components: {
      talkPart,
      VueAudio,
      XieYi
    },
    mixins: [sideBarMixin],
    data() {
      return {
        baseUrl:process.env.config.RRDH_HOST,
        isShow: false,
        headTitle: "title---rrdh",
        headKeywords: "keywords---rrdh",
        headDesc: "description---rrdh",
        isMounted: false, //for control not ssr render
        model: {},
        fileList: [],
        fileFormats:[],
        modelList: [],
        userInfo: {},
        callbackurl: "",
        isReload: false,
        objId: 0,
        payStatus: false,
        isFree: true,
        payShow: true,
        dialogXieyi: false,
        agree: false,
        playState: false,
        audioSrc: '',
      }
    },
    beforeMount() {
      // let id = this.$route.query.id
      // if (id) {
      //   this.objId = parseInt(id)
      // }
      // console.log('--------',id)

    },
    computed: {
      ...mapState(["modelDetail"])
    },
    tdk() {
      return {
        title: this.headTitle,
        description: this.headDesc,
        keywords: this.headKeywords,
        ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
      };
    },
    serverPrefetch() {
      return this.fetchData();
    },
    destroyed() {
      this.$store.commit("SET_MODEL_DETAIL", {detail: null});
    },
    mounted() {

      // let id = this.$route.query.id
      this.callbackurl = "login?callback=" + window.location.href;

      const alreadyIncremented = !!this.modelDetail;
      if (!alreadyIncremented) {
        this.fetchData().then(
                setTimeout(() => {
                  this.initData()
                }, 1500)
        );
      } else {
        setTimeout(() => {
          this.initData()
        }, 1500)
      }
    },
    methods: {
      changeState (state) {
        // console.log(state)
        this.playState = state
      },
      download() {
        if (!this.global.isLogin) {
          window.location.href = "http://www.renrendonghua.com/" + this.callbackurl;
        }
      },
      toPay() {
        this.dialogXieyi = false
        if (!this.global.isLogin) {
          window.location.href = "http://www.renrendonghua.com/" + this.callbackurl;
        } else {
          this.$router.push({
            path: '/pay?id=' + this.model.id
          })
        }
      },
      setSeo() {
        this.headTitle = this.modelDetail.modelName + "——音效库——人人动画网";
        this.headKeywords = this.modelDetail.dictionaryNames;
        let desc = this.modelDetail.modelDescription.replace(/<\/?.+?>/g, "").trim()
        this.headDesc = desc.substr(0, 150);
      },
      fetchData() {
        this.$loading(true)
        const cookies = this.$ssrContext && this.$ssrContext.cookies
        return this.$store
                .dispatch("FETCH_MODEL_DETAIL", {
                  id: this.$route.query.id
                })
                .finally(() => {
                  this.$loading(false);
                  this.setSeo()
                  updateTdk.call(this);
                });
      },
      initData() {
        setTimeout(()=>{
          this.reloadModel()
        },1500)
        let _this = this;
        _this.model = _this.modelDetail

        _this.objId = parseInt(_this.model.id)
        // console.log(_this.objId)
        modelApi.select(_this.objId).then(data => {
          if (data.code == 1) {
            _this.model = data.response
            if (_this.model.deleteFlag == 1) {
              this.$router.push({
                path: '/error',
              })
            } else if (_this.model.auditStatus != 1) {
              this.$message.error("音效素材修改审核中")
            } else {
              _this.isShow = true
              _this.isMounted = true;
              _this.userThreeModel(_this.model.creatorId);
              _this.getUserInfo(_this.model.creatorId)
              _this.fileList = data.response.fileList
              _this.audioSrc = _this.fileList[0].url
              _this.fileFormats = data.response.fileFormats

              if (_this.model.modelPrice > 0) {
                _this.isFree = false
                _this.payShow = true
              } else {
                _this.isFree = true
                _this.payShow = false
              }
              if (!_this.global.isLogin && !_this.isFree) {
                _this.payShow = true
              }
              if (_this.global.isLogin && !_this.isFree) {
                _this.ifPayed()
              }

              modelApi.updateCountNum(_this.objId).then(r => {
                console.log(r)
              })
            }

          } else {
            _this.$message.error(data.message)
          }
        })
      },
      userThreeModel(userId) {
        let _this = this
        modelApi.userThreeModel(userId,2).then(data => {
          // console.log(data)
          if (data.code == 1) {
            _this.modelList = data.response
          }
        })
      },
      getUserInfo(userId) {
        let _this = this;
        let url = '/rrbi/userInfo/userInfo/' + userId + '?time=' + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
          if (result.data.code == 1) {
            _this.userInfo = result.data.response
          }
        })
      },
      undoFollower(userId) {
        let _this = this;
        let url = '/api/checkLogin?time=' + new Date().getMilliseconds();
        this.$axios.get(url).then(function (result) {
          if (result.data.isLogin && result.data.casFastUserModel != null) {

            homeApi.undoFollower(userId).then(data => {
              // console.log(data)
              const status = data.response.status
              if (status == 1) {
                _this.userInfo.followStatus = 0
                _this.$message.success("取消成功")
              } else {
                _this.$message.error("取消失败")
              }
            })

          } else {
            window.location.href = "http://www.renrendonghua.com/" + _this.callbackurl;

          }
        })

      },
      follower(userId) {
        let _this = this;
        let url = '/api/checkLogin?time=' + new Date().getMilliseconds();
        this.$axios.get(url).then(function (result) {
          if (result.data.isLogin && result.data.casFastUserModel != null) {

            homeApi.follower(userId).then(data => {
              // console.log(data)
              const status = data.response.status
              if (status != -1) {
                _this.userInfo.followStatus = status
                _this.$message.success("关注成功")
              } else {
                _this.$message.error("关注失败")
              }
            })

          } else {
            window.location.href = "http://www.renrendonghua.com/" + _this.callbackurl;

          }
        })

      },
      likeEvent(id,belongSection) {
        var _this = this;
        if (_this.global.isLogin) {
          apiService.dolike({
            "objectType": 6,
            "objectId": id,
            "belongSection":belongSection,
            "time": new Date().getMilliseconds()
          }).then(data => {

            _this.model.likeFlag = !_this.model.likeFlag
            if (_this.model.likeFlag) {
              _this.model.likeCount += 1
            } else {
              _this.model.likeCount -= 1
            }
            // 重新渲染组件
            _this.reloadModel()
          })
        } else {
          _this.toLog()
        }

      },
      disLikeEvent(id,belongSection) {
        var _this = this;
        if (_this.global.isLogin) {
          apiService.dislike({
            "objectType": 6,
            "objectId": id,
            "belongSection":belongSection,
            "time": new Date().getMilliseconds()
          }).then(data => {

            _this.model.disLikeFlag = !_this.model.disLikeFlag
            if (_this.model.disLikeFlag) {
              _this.model.dislikeCount += 1
            } else {
              _this.model.dislikeCount -= 1
            }
            // 重新渲染组件
            _this.reloadModel()
          })
        } else {
          _this.toLog()
        }
      },
      reloadModel() {
        let _this = this
        // 移除组件
        _this.isReload = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        _this.$nextTick(() => {
          _this.isReload = true
        })
      },
      toLog() {
        this.$router.push({
          path: '/login?callback=' + window.location.href,
        })

      },
      commitCollect(id) {
        var _this = this;
        if (_this.global.isLogin) {
          apiService.saveCollect({"objectType": 6, "objectId": id}).then(data => {
            // console.log(data);
            _this.$message({
              message: '成功加入收藏',
              type: 'success'
            });
            _this.model.collectFlag = true
            _this.model.collectCount += 1
          })
        } else {
          window.location.href = "http://www.renrendonghua.com/" + _this.callbackurl;
        }
      },
      cancelCollect(id) {
        var _this = this;
        _this.$confirm('确认取消收藏吗？')
                .then(_ => {
                  let url = '/rrbi/collect/delCollect?objectId=' + id + '&objectType=6&time=' + new Date().getMilliseconds();
                  _this.$axios.get(url).then(function (result) {
                    // console.log(result)
                    if (result.data == 1) {
                      _this.$notify({
                        title: '已取消收藏',
                        type: 'success',
                        showClose: false,
                        duration: 2000
                      })
                      _this.model.collectFlag = false

                      _this.model.collectCount -= 1
                    } else {
                      _this.$message.error("取消失败")
                    }
                  })
                })
                .catch(_ => {
                  // console.log('取消')
                })
      },
      ifPayed() {
        var _this = this;
        if (_this.global.isLogin) {
          let url = '/rrbi/pay/ifPayed?productId=' + _this.model.id + '&orderType=1&time=' + new Date().getMilliseconds();
          _this.$axios.get(url).then(function (result) {
            if (result.data == 1) {
              _this.payStatus = true
              _this.payShow = false
            } else {
              _this.payStatus = false
              _this.payShow = true
            }
          })
        } else {
          window.location.href = "http://www.renrendonghua.com/" + _this.callbackurl;
        }
      },
      addDownloadCount(row) {
        modelApi.updateDownloadCountNum(this.objId).then(r => {
          console.log(r)
        })
        window.location.href = "/rrbi/upload/download/"+row.id;
      },
      toPayXy () {
        if (!this.global.isLogin) {
          window.location.href = "http://www.renrendonghua.com/" + this.callbackurl;
        } else {
          this.dialogXieyi = true
        }
      },
      doShare(){
        this.$refs.talkPart.share();
      }
    }

  }
</script>

<style scoped lang="less">
  //@import "../../../../assets/less/stylePublic.less";
  @import "../../../model/detail/detail.less";
  @import "../../../course/detail/detail.less";
  .play-audio{
    padding: 20px;
    width: 100%;
    .pan{
      position: relative;
      margin: 0 auto;
      width: 50%;
      .pan-img{
        display: block;
        width: 100%;
        animation: rotatePan 15s linear 0s infinite;
        @keyframes rotatePan {
          0%   {transform: rotate(-360deg);}
          100% {transform: rotate(0deg);}
        }
        &.paused{
          animation-play-state: paused;
        }
        &::selection{
          background: none;
        }
      }
      .mai{
        position: absolute;
        right: -24%;
        top: 0;
        width: 25%;
        transform-origin: 60% 15.9%;
        transform: rotate(0deg);
        transition: transform .2s linear;
        &.play{
          transform: rotate(40deg);
        }
        .mai-img{
          display: block;
          width: 100%;
          &::selection{
            background: none;
          }
        }
      }
    }
  }
  .audio-works{
    margin-top: 10px;
    .itemm{
      float: left;
      padding: 4px;
      margin-right: 2.3%;
      width: 31.8%;
      background: #fff;
      border: 1px solid #dfdee3;
      border-radius: 2px;
      img{
        margin: 0 auto;
        display: block;
        width: 40px;
        height: 40px;
      }
      p{
        margin-top: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
  @media screen and (max-width: 750px){
    .play-audio{
      padding: 0;
    }
  }
</style>
